module.exports = __webpack_public_path__ + "4685771109f3923ce0ed1c890f91a01f.png";